import { useMemo } from 'react';
import { createValidators } from 'validators';
import { useLocaleKeys } from '~/i18n';
export function useValidationRules() {
    const { t } = useLocaleKeys('common.validation');
    return useMemo(()=>createValidators({
            fieldNames: {
                name: t.fieldNames.name(),
                title: t.fieldNames.title(),
                streetName: t.fieldNames.streetName(),
                cityName: t.fieldNames.cityName(),
                postalCode: t.fieldNames.postalCode(),
                companyName: t.fieldNames.companyName(),
                phoneNumber: t.fieldNames.phoneNumber(),
                invoicePrefix: t.fieldNames.invoicePrefix()
            },
            tooShort: (param)=>{
                let { field, min } = param;
                return t.tooShort({
                    field,
                    min
                });
            },
            tooLong: (param)=>{
                let { field, max } = param;
                return t.tooLong({
                    field,
                    max
                });
            },
            htmlCharacters: (param)=>{
                let { field } = param;
                return field ? t.htmlCharacters({
                    field
                }) : t.htmlCharactersNoField();
            },
            streetCharacters: (param)=>{
                let { field } = param;
                return t.streetCharacters({
                    field
                });
            },
            nameCharacters: (param)=>{
                let { field } = param;
                return t.nameCharacters({
                    field
                });
            },
            poBox: ()=>t.poBox(),
            invalid: (param)=>{
                let { field } = param;
                return t.invalid({
                    field
                });
            },
            invalidEmail: ()=>t.invalidEmail(),
            invalidUsPhone: ()=>t.invalidUsPhone(),
            mustContainLetter: (param)=>{
                let { field } = param;
                return t.mustContainLetter({
                    field
                });
            },
            invoicePrefixFormat: (param)=>{
                let { field, min, max } = param;
                return t.invoicePrefixFormat({
                    field,
                    min,
                    max
                });
            }
        }), []);
}
